import React from 'react';
import { UrgentCTA } from './UrgentCTA';
import { PriceDisplay } from './PriceDisplay';
import { CheckIcon, TrendingDownIcon } from 'lucide-react';
const features = ['Curso completo de Placas Aromáticas Artesanales', 'Videos paso a paso - Desde cero hasta profesional', 'Lista de proveedores confiables', 'Fórmulas exactas y recetas probadas', 'Todos los bonos incluidos ($25,000)', 'Soporte 24/7 para ayudarte', 'Actualizaciones gratuitas de por vida'];
export function PricingCard() {
  return <section className="bg-gradient-to-b from-pink-50 via-white to-amber-50 py-12 md:py-20 px-4" data-id="element-96">
      <div className="container mx-auto max-w-4xl" data-id="element-97">
        <div className="text-center mb-8 md:mb-12" data-id="element-98">
          <h2 className="text-3xl md:text-5xl font-extrabold text-pink-600 mb-4 leading-tight" data-id="element-99">
            ¿Cuánto cuesta cambiar tu vida?
          </h2>
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-100">
            <TrendingDownIcon className="w-8 h-8 md:w-10 md:h-10 text-rose-500 animate-bounce" aria-hidden="true" data-id="element-101" />
            <p className="text-xl md:text-3xl text-rose-500 font-extrabold uppercase" data-id="element-102">
              ¡64% de Descuento HOY!
            </p>
            <TrendingDownIcon className="w-8 h-8 md:w-10 md:h-10 text-rose-500 animate-bounce" aria-hidden="true" data-id="element-103" />
          </div>
        </div>

        <article className="bg-white border-4 border-pink-400 rounded-2xl p-8 md:p-12 shadow-2xl animate-glow" data-id="element-104">
          {/* Price */}
          <div className="text-center mb-8 md:mb-10" data-id="element-105">
            <p className="text-lg md:text-xl text-stone-600 font-bold mb-2" data-id="element-106">
              Valor Real del Programa + Bonos:
            </p>
            <p className="text-3xl md:text-4xl text-stone-500 line-through font-bold mb-4" data-id="element-107">
              $52,000
            </p>

            <div className="bg-gradient-to-r from-pink-500 to-rose-500 text-white py-3 px-6 rounded-lg inline-block mb-6 animate-pulse-urgent shadow-lg" data-id="element-108">
              <p className="text-sm md:text-base font-extrabold uppercase" data-id="element-109">
                OFERTA ESPECIAL HOY:
              </p>
            </div>

            <PriceDisplay basePrice={18999} className="mb-4" data-id="element-110" />

            <p className="text-base md:text-lg text-pink-600 font-bold mt-4" data-id="element-111">
              💡 Con la venta de tus primeras 3-4 placas ya recuperaste tu
              inversión
            </p>
          </div>

          {/* Features */}
          <div className="space-y-4 mb-8 md:mb-10" data-id="element-112">
            {features.map((feature, index) => <div key={index} className="flex items-center gap-3" data-id="element-113">
                <div className="bg-pink-500 rounded-full p-1 flex-shrink-0" data-id="element-114">
                  <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-115" />
                </div>
                <p className="text-base md:text-lg text-stone-800 font-semibold" data-id="element-116">
                  {feature}
                </p>
              </div>)}
          </div>

          {/* CTA */}
          <UrgentCTA size="large" data-id="element-117">🚀 SÍ, QUIERO EMPEZAR AHORA 🚀</UrgentCTA>

          <div className="mt-6 text-center space-y-2" data-id="element-118">
            <p className="text-sm md:text-base text-pink-600 font-bold" data-id="element-119">
              ✓ Acceso inmediato al curso completo
            </p>
            <p className="text-sm md:text-base text-pink-600 font-bold" data-id="element-120">
              ✓ Todos los bonos incluidos
            </p>
            <p className="text-sm md:text-base text-pink-600 font-bold" data-id="element-121">
              ✓ Resultados en menos de 24 horas
            </p>
          </div>
        </article>

        {/* Urgency reminder */}
        <div className="mt-8 text-center" data-id="element-122">
          <p className="text-base md:text-lg text-stone-600 font-bold mb-2" data-id="element-123">
            P.D. Recordá: esta oferta de $18,999 vence en 10 minutos.
          </p>
          <p className="text-lg md:text-2xl text-rose-500 font-extrabold uppercase animate-flash" data-id="element-124">
            ⏰ Después vuelve al precio normal de $52,000
          </p>
          <p className="text-base md:text-lg text-pink-600 font-bold mt-4" data-id="element-125">
            No dejes pasar esta oportunidad de cambiar tu situación económica.
          </p>
        </div>
      </div>
    </section>;
}